function BoxImgRight(container){
	var _this = this;
	this.container = $(container);
	this.boxImg = this.container.find('img');
	this.boxImgText = this.container.find('.box-img-text').css({top: 'auto', bottom: 0});
	this.boxImgTitle = this.container.find('.box-title');
	this.boxImgHeight = this.container.height();
	this.boxImgTitleHeight = this.boxImgTitle.height();
	this.container.bind({
		mouseenter: function(){
			_this.boxImg.animate({opacity: .3},{duration: 200, easing: 'easeOutCubic', queue: false});
			_this.boxImgTitle.animate({height: 110},{duration: 200, easing: 'easeOutCubic', queue: false});
		},
		mousedown: function(){
			_this.boxImg.animate({opacity: 0},{duration: 200, easing: 'easeOutCubic', queue: false});
			_this.boxImgTitle.animate({height: _this.boxImgHeight},{duration: 200, easing: 'easeOutCubic', queue: false});
		},
		click: function(){
			_this.boxImgTitle.click();
		},
		mouseleave: function(){
			_this.boxImg.animate({opacity: 1},{duration: 200, easing: 'easeOutCubic', queue: false});
			_this.boxImgTitle.animate({height: _this.boxImgTitleHeight},{duration: 200, easing: 'easeOutCubic', queue: false});
		}
	});
}

if (typeof define === "function" && define.amd) {
	define('Controls/BoxImgRight',['easing'], function() {
		return BoxImgRight;
	});
};
